
import dayjs from "dayjs";
export default {
  computed: {
    locais() {
      return [
        {
          icon: "mdi-cash",
          text: this.forma_pagamento,
          title: "Forma Mensalidade",
        },
        {
          icon: "mdi-briefcase-account-outline",
          text: this.forma_adesao || "Isento",
          title: "Forma adesão",
        },
        {
          icon: "mdi-currency-usd-off",
          text: this.isento == 1 ? "Isento" : "Não Isento",
          title: "Taxa de adesão",
        },
        {
          icon: "mdi-account",
          text: this.valor_adesao || "Isento",
          title: "Valor Adesão",
        },
        {
          icon: "mdi-account-tie",
          text: this.vendedor,
          title: "Vendedor",
        },
        {
          icon: "mdi-calendar",
          text: this.data(this.abertura),
          title: "Data da venda",
        },
        {
          icon: "mdi-alert",
          text: this.indicado,
          title: "Local aonde foi indicado",
        },
        {
          icon: "mdi-storefront",
          text: this.unidade,
          title: "Unidade",
        },
      ];
    },
  },
  props: {
    forma_pagamento: String,
    forma_adesao: String,
    valor_adesao: Number,
    vendedor: String,
    abertura: String,
    indicado: String,
    unidade: String,
    isento: Number,
  },

  methods: {
    data(date) {
      return dayjs(date).format("DD/MM/YYYY HH:mm");
    },
  },
};
